import { motion } from "framer-motion";
import { Banknote, QrCode, CreditCard, DollarSign, Smartphone, Sparkles } from "lucide-react";
import { PAYMENT_METHODS } from "@/data";

const ICONS = { Banknote, QrCode, CreditCard, DollarSign, Smartphone, Sparkles };

export const Payments = () => (
  <section id="payments" data-testid="payments-section" className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-2xl mb-12">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-cosmic-yellow">Payment</span>
        <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
          Pay <span className="text-gradient-candy">your way</span>
        </h2>
        <p className="mt-4 text-base text-slate-400 leading-relaxed">
          Submit your order or booking request, we confirm the details with you, then you pay
          however is easiest. No online checkout required.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="payment-grid">
        {PAYMENT_METHODS.map((pm, i) => {
          const Icon = ICONS[pm.icon] || Sparkles;
          return (
            <motion.div
              key={pm.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: i * 0.06 }}
              className="glass rounded-2xl p-5 text-center transition-transform duration-300 hover:-translate-y-1.5 hover:border-cosmic-cyan/40"
              data-testid={`payment-${pm.name.toLowerCase().replace(/[^a-z]/g, "-")}`}>
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-cosmic-pink/25 to-cosmic-cyan/25 border border-white/10">
                <Icon size={20} className="text-white" />
              </div>
              <div className="mt-3 font-display text-sm font-bold text-white">{pm.name}</div>
              <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.12em] text-slate-400">{pm.badge}</div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default Payments;
